module.exports = __webpack_public_path__ + "static/img/11.f81e7b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/11.jpg
// module id = SYMP
// module chunks = 1